<form [formGroup]="userForm" (ngSubmit)="onSubmit()">
    <div class="form-control">
        <label for="firstName"  class="required-field">
            First Name:
        </label>
        <input
            pInputText 
            id="firstName"
            formControlName="firstName">
        <div [ngClass]="{'visible': userForm.invalid}" class="form-control-messsage error-msg">
            <span *ngIf="userForm.controls['firstName'].errors?.['pattern']">
                Invalid first name.
            </span>
        </div>
    </div>
    <div class="form-control mt-2">
        <label for="lastName"  class="required-field">
            Last Name:
        </label>
        <input
            pInputText 
            id="lastName"
            formControlName="lastName">
        <div [ngClass]="{'visible': userForm.invalid}" class="form-control-messsage error-msg">
            <span *ngIf="userForm.controls['lastName'].errors?.['pattern']">
                Invalid last name.
            </span>
        </div>
    </div>
    <div class="form-control mt-2">
        <label for="location"  class="required-field">
            Location (City):
        </label>
        <input
            pInputText 
            id="location"
            formControlName="city">
        <div [ngClass]="{'visible': userForm.invalid}" class="form-control-messsage error-msg">
            <span *ngIf="userForm.controls['city'].errors?.['pattern']">
                Invalid location.
            </span>
        </div>
    </div>
    <div class="form-control mt-2">
        <label for="email"  class="required-field">
            Email:
        </label>
        <input
            pInputText 
            id="email"
            formControlName="email">
        <div [ngClass]="{'visible': userForm.invalid}" class="form-control-messsage error-msg">
            <span *ngIf="userForm.controls['email'].errors?.['pattern']">
                Invalid email format.
            </span>
        </div>
    </div>
    <div class="form-control mt-2">
        <label for="userRole"  class="required-field">
            User Role:
        </label>
        <p-dropdown
            id="userRole"
            [options]="roles"
            optionLabel="name"
            optionValue="name"
            placeholder="select role"
            formControlName="role"></p-dropdown>
        <div [ngClass]="{'visible': userForm.invalid}" class="form-control-messsage error-msg">
            <span *ngIf="userForm.controls['role'].errors?.['require']">
                User type is required.
            </span>
        </div>
    </div>
    
    <div class="form-buttons">
        <button 
            [disabled]="userForm.invalid"
            pButton 
            type="submit" 
            label="Save"></button>
    </div>
</form>